import BallSelector from './ball-selector';
import Overlay from './overlay';

if (__DEV__) {
  console.log('DEVELOPMENT ENVIRONMENT');
}
if (__SRC__) {
  console.log('SOURCE ENVIRONMENT');
}
if (__DIST__) {
  console.log('DISTRIBUTION ENVIRONMENT');
}

const products = {ids: {
  v1: 114,
  v1x: 115,
  avx: 2677,
  v1xld: 3419,
  'tour-soft': 2678,
  velocity: 2712,
  trufeel: 3021
}
};

const productsYellow = {
  ids: {
    v1: 3421,
    v1x: 3437,
    avx: 3453,
    'tour-soft': 2695,
    trufeel: 3037
  }
};

// /**
//  * IFRAME RESIZING
//  */
function scrollToMiddle() {
  if (typeof window.ballSelector === 'undefined' || window.ballSelector == null) {
    return;
  }

  window.parent.postMessage(["scrollToMiddle"], "*");
}

function resizeFrame() {
  if (typeof window.ballSelector === 'undefined' || window.ballSelector == null) {
    return;
  }

  let height = window.ballSelector.getHeight();
  if (height != window.lastHeight) {
    window.parent.postMessage(["frameHeight", height], "*");
    window.lastHeight = height;
  }
}
window.lastHeight = 0;
window.resizeFrame = resizeFrame;
window.scrollToMiddle = scrollToMiddle;
resizeFrame();
window.addEventListener('load', resizeFrame);
window.addEventListener('resize', resizeFrame);

let overlay = new Overlay();
window.showResultsError = function () {
  overlay.showResultsError();
}
window.showResultsSuccess = function () {
  overlay.showResultsSuccess();
}

/***
 *
 * TODO: If logged in to Team Titleist call this function to prepopulate the email field:
 * window.setInitialEmailValue('tom@sample.com');
 *
 */
window.setInitialEmailValue = function (email) {
  console.log('window.setInitialEmailValue: ' + email)
  // let overlay = new Overlay();
  // overlay.setInitialEmailValue(email);
}
// window.setInitialEmailValue('tom@sample.com');

var applyFullName = function(code, color){
  var ballName = code;
  switch (code) {
    case 'v1':
      ballName = 'Pro V1';
      break;
    case 'v1x':
      ballName = 'Pro V1x'
      break;
    case 'v1xld':
      ballName = 'Pro V1x Left Dash';
      break;
    case 'avx':
      ballName = 'AVX';
      break;
    case 'tour-soft':
      ballName = 'Tour Soft';
      break;
    case 'velocity':
      ballName = 'Velocity';
      break;
    case 'trufeel':
      ballName = 'TruFeel';
      break;
  }

  if (color.toLowerCase() == 'yellow') {
    ballName += ' Yellow';
  }

  return ballName;
};

var getProductId = function (code, color) {
  if (color.toLowerCase() == 'yellow') {
    return productsYellow.ids[code];
  }

  return products.ids[code];
}

/***
 *
 * TODO: Titleist needs to write the ajax call here. Fake sample timer shows results options.
 * I think that you could move this function outside of this file if that helps.
 * Valid ids: t100, t100s, t200, t300, 620mb, 620cb
 *
 */
window.submitResultsForm = function (email, primaryId, primaryColor, alternateId, alternateColor) {
  console.log('window.submitResultsForm: ' + email + ' primaryId: ' + primaryId + ' primaryColor: ' + primaryColor + ', alternateId: ' + alternateId + ' alternateColor: ' + alternateColor);
  //Put ajax calls here using parameter variable?
  
  var xmlhttp = new XMLHttpRequest();   // new HttpRequest instance
  xmlhttp.onreadystatechange = function()
        {
            if(xmlhttp.readyState == 4)
            {
              if(xmlhttp.responseText != undefined){
                let responseM = JSON.parse(xmlhttp.responseText);
                if(responseM.Message == "Success")
                  window.showResultsSuccess();
                else
                  window.showResultsError();
              }

              else
              {
                window.showResultsError();
              }
            }

        } 
  xmlhttp.open("POST", resutlsHook);
  let terms = document.querySelectorAll('#terms');
  let optin = false;

  if (terms && terms[0].checked) { 
      optin = true;
  }

  var formData = new FormData();
  var primaryProductId = getProductId(primaryId, primaryColor);
  var alternateProductId = getProductId(alternateId, alternateColor);
  formData.append("productids", primaryProductId);
  formData.append("productids", alternateProductId);

  var primaryName = applyFullName(primaryId, primaryColor);
  var alternateName = applyFullName(alternateId, alternateColor);

  console.log('SUBMIT ' + primaryProductId + ' ' + alternateProductId + ' ' + primaryName + ' ' + alternateName);

  formData.append("email", email);
  formData.append("products", primaryName);
  formData.append("products", alternateName);
  formData.append("source", "Golf Ball Selector");
  formData.append("optin", optin);
  //var jsondata = JSON.stringify({email: email, products : [primaryId, alternateId], source: "Golf Ball Selector"});
  xmlhttp.send(formData);
  // fake timer here and sample for success and error results.
  //setTimeout( function () {
    // just showing error if you use this email address for testing
    //if (email.toLowerCase() === 'error@error.com') {
      //if error
      //window.showResultsError();
    //} else {
      //if success
      //window.showResultsSuccess();
    //}

  //}, 1200);
}



// Star the app
window.ballSelector = new BallSelector();

